/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import FormLayout from '../layout/form';

export interface ErrorMessageProps{
  message?: string
  code?: any
}

export default function ({message,code}:ErrorMessageProps) {
  if (!!message && !!code ){
    if(code != 401){
      return (
        <FormLayout header="Something went wrong" button={<></>} />
        );
    } else {
      return (
        <FormLayout header={message}  button={<></>}></FormLayout>
        );
    }
  } else { 
    console.log("no message no code " , message,code)
    return <FormLayout header="Something went wrong" button={<></>} />
  }
};